import { PiniaColada } from "@pinia/colada";
import * as Sentry from "@sentry/vue";
import FloatingVue from "floating-vue";
import { createPinia } from "pinia";
import { createApp } from "vue";

// import "./font.css";
import "./style.css";

import "./styles/skapa.ts";
import "@ikeacn/ui/lib/index.css";
import "@ikeacn/fonts/src/index.css";
import "vue-awesome-paginate/dist/style.css";
import "floating-vue/dist/style.css";

import VueAwesomePaginate from "vue-awesome-paginate";
import VueKonva from "vue-konva";

import { i18n } from "@/locales";

import App from "./app.vue";
import { DEV_HOSTNAME, PROD_HOSTNAME } from "./constants/config.ts";
import router from "./routes/router";

const app = createApp(App);

const hostname = location.hostname;

Sentry.init({
  app,
  dsn: "https://04a78bdb73e6a2af6c1dbca7ace74fd9@o478484.ingest.us.sentry.io/4512259152281600",
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  environment:
    hostname === PROD_HOSTNAME ? "production" : hostname === DEV_HOSTNAME ? "dev" : "local",
  // Tracing
  tracesSampleRate: 1.0, // Capture 100% of the traces
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ["localhost"],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app
  .use(router)
  // auth0 SDK must be registered after router
  // https://github.com/auth0/auth0-vue/blob/main/EXAMPLES.md#protecting-a-route
  // .use(auth1)
  .use(VueAwesomePaginate)
  .use(VueKonva)
  .use(FloatingVue, {
    themes: {
      // menu without the arrow
      "menu-v1": {
        $extend: "menu",
      },
    },
  })
  .use(i18n)
  .use(createPinia())
  .use(PiniaColada)
  .mount("#app");
